<template>
  <div class="h-100 d-flex gap-20px">

    <div class="d-flex gap-10 draw-settings h-100 py-2">
      <div class="w-100 magic-tool" @click="undo" v-bind:class="{ 'disabled': activeStage.canvas.historyIndex <= 0}"><i class="fa fa-redo fa-redo-undo"></i> <span v-if="resultPage.isFullRes === true">{{ 'Undo' | trans }}</span></div>
      <div class="w-100 magic-tool" @click="redo" v-bind:class="{ 'disabled': activeStage.canvas.history.length ===  activeStage.canvas.historyIndex + 1}"><i class="fa fa-redo"></i> <span v-if="resultPage.isFullRes === true">{{ 'Redo' | trans }}</span></div>
    </div>

    <div class="py-2 h-100">
      <div @click="setTool('freeDrawingBrush')" class="magic-tool" v-bind:class="{ 'active': activeStage.canvas.activeTool === 'freeDrawingBrush'}">
        <i class="far fa-pencil"></i>
        <span>{{ 'Brush' | trans }}</span>
      </div>
    </div>

    <div class="d-flex align-items-center gap-10px py-1">
      <span v-if="resultPage.isFullRes === true">{{ 'Brush width' | trans }}</span>
      <input
        type="range"
        class="form-control-range range-slider flex-1"
        id="formControlRange"
        min="0"
        max="250"
        v-model.number="activeStage.canvas.settings.freeDrawingBrush.width"
        @change="setTool(activeStage.canvas.activeTool)"
      >
    </div>

  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import CanvasManager from "../../manager/CanvasManager";

export default {
  name: "DrawSettings",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob
  ],
  data() {
    return {
      item_open: false
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    setTool(tool) {
      switch (tool) {
        case 'eraser':
          break;
        case 'freeDrawingBrush':
          CanvasManager.setToolFreeDrawingBrush(this.activeStage);
          break;
      }
    },
    undo() {
      CanvasManager.undo(this.activeStage);
    },
    redo() {
      CanvasManager.redo(this.activeStage);
    },
    next() {
      if (this.isDone === false) {
        return;
      }
      this.activeStage.activeStep = 'prompt';
      CanvasManager.setPreviewOriginal(this.activeStage);
    },
    activate() {
      if (this.isActive === false) {
        return;
      }
      this.activeStage.activeStep = 'draw';
      this.activeStage.preview = false;
    }
  },
  computed: {
    isActive() {
      return this.activeStage.mainJob !== null && this.currentJob.state !== 'processing' && this.activeStage.sysJobs.length === 0;
    },
    isDone() {
      return this.activeStage.canvas.historyIndex > 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.draw-settings {
  border-right: 1px solid #595959;
  padding-right: 20px;
}
.fa-redo-undo {
  transform: scaleX(-1);
}
.magic-action-btn {
  height: 50px;
  display: inline-flex;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  border: 2px solid white;
  border-radius: 4px;
  gap: 10px;
  cursor: pointer;
}

.magic-tool {
  cursor: pointer;
  height: 100%;
  display: inline-flex;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  border: 2px solid white;
  border-radius: 4px;
  gap: 10px;

  &.active {
    border: 2px solid #1266F1;
    //color: #1266F1;
  }
}

.gap-10px {
  gap: 10px;
}

.gap-20px {
  gap: 20px;
}

.gap-30px {
  gap: 30px;
}

.gap-40px {
  gap: 40px;
}

.upload-box-item {
  height: 250px;
}

.next-btn {
  &.disabled {
    cursor: not-allowed;
  }
  border: none;
  color: white;
  border-radius: 4px;
  background: #1266F1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 20px;
  gap: 20px;
  font-size: 17.5px;
}
</style>
